<template>
    <div>
        <div style="padding-bottom: 30px;">
<!--             <div class="info-page-header">
                <div>
                    <div class="shop-image"></div>
                </div>
                <div class="shop-header-name">
 -->
                    <h1 class="pt-4">Thông tin cửa hàng</h1>

                <!-- </div>
            </div> -->
            <div class="info-page-body">
                <div class="card mb-5 mb-3">
                    <div class="info-title">
                        <h3>Thông tin cửa hàng</h3>
                        <div class="title-btn">
                            <el-button type="primary" outline native-type="submit" style="margin-left: 5px"
                                @click="handleOpenUpdate(false)">
                                <span class="btn-inner--icon"><i class="fas fa-wrench"></i></span>
                                <span class="btn-inner--text">&nbsp;Cập nhật</span>
                            </el-button>
                        </div>
                    </div>
                    <div>
                        <div class="info-card">
                            <label class="info">Tên cửa hàng:</label>
                            <span class="info data">{{ Shop.cTenCuaHang }}</span>
                        </div>
                        <div class="info-card">
                            <label class="info">Địa chỉ:</label>
                            <span class="info data">{{ Shop.cDiaChi }}</span>
                        </div>
                        <div class="info-card">
                            <label class="info">Số điện thoại:</label>
                            <span class="info data">{{ Shop.cDienThoai }}</span>
                        </div>
                        <div class="info-card">
                            <label class="info">Ảnh đại diện:</label>
                            <img class="avatar-shop" v-if="Shop.profileImage" :src="renderImg(Shop.profileImage)" />
                        </div>
                        <div class="info-card">
                            <label class="info">Ảnh bìa:</label>
                            <img style="width: 60%; height: 30%;" v-if="Shop.profileBanner"
                                :src="renderImg(Shop.profileBanner)" />
                        </div>
                    </div>
                </div>
                <div class="card mb-5 mb-3">
                    <div class="info-title">
                        <h3>Giới thiệu cửa hàng</h3>
                        <div class="title-btn">
                            <el-button v-if="!dUpdate" type="primary" outline native-type="submit"
                                style="margin-left: 5px" @click="handleOpenDescription">
                                <span class="btn-inner--icon"><i class="fas fa-wrench"></i></span>
                                <span class="btn-inner--text">&nbsp;Cập nhật</span>
                            </el-button>
                            <el-button v-if="dUpdate" type="success" outline native-type="submit"
                                style="margin-left: 5px" @click="handleUpdateDescription">
                                <span class="btn-inner--icon"><i class="fas fa-wrench"></i></span>
                                <span class="btn-inner--text">&nbsp;Lưu</span>
                            </el-button>
                            <el-button v-if="dUpdate" type="danger" outline native-type="submit"
                                style="margin-left: 5px" @click="handleCancelDescription">
                                <span class="btn-inner--icon"><i class="fas fa-wrench"></i></span>
                                <span class="btn-inner--text">&nbsp;Hủy</span>
                            </el-button>
                        </div>
                    </div>
                    <div>
                        <div class="info-card">
                            <!-- <span  class="info ">{{ Shop.cGioiThieu }}</span> -->
                            <div class="test" v-if="!dUpdate" v-html="Shop.cGioiThieu"></div>
                            <div class="input" v-else>
                                <div class="w-100">
                                    <QuillEditor class="w-100 d-flex flex-column" ref="quillEditor"
                                        @text-change="onTextChange" :options="quillOptions" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card mb-5 mb-3 certi">
                    <div class="info-title">
                        <h3>Giấy phép</h3>
                    </div>
                    <div>
                        <div class="info-card CerCard" style="justify-content: flex-start;" v-for="item in certificate"
                            @click="handleOpenCertificate(item)">
                            <span class="info data">{{ item.c_ten_giay_phep }}</span>
                        </div>
                        <div class="info-card CerCard" @click="handleOpenAddCer">
                            <label class="info">Thêm giấy phép...</label>
                            <span class="addIcon"><i class="fa fa-plus"></i></span>
                        </div>
                    </div>
                </div>
                <div class="card mb-5 mb-3">
                    <div class="info-title">
                        <h3>Tài khoản ngân hàng</h3>
                        <div class="title-btn">
                            <el-button type="primary" outline native-type="submit" style="margin-left: 5px"
                                @click="handleOpenUpdate(true)">
                                <span class="btn-inner--icon"><i class="fas fa-wrench"></i></span>
                                <span class="btn-inner--text">&nbsp;Cập nhật</span>
                            </el-button>
                        </div>
                    </div>
                    <div>
                        <div class="info-card">
                            <label class="info">Số tài khoản:</label>
                            <span class="info data">{{ Shop.cSoTaiKhoanNganHang }}</span>
                        </div>
                        <div class="info-card">
                            <label class="info">Tên chủ tài khoản:</label>
                            <span class="info data">{{ Shop.cTenChuTaiKhoan }}</span>
                        </div>
                        <div class="info-card">
                            <label class="info">Tên ngân hàng:</label>
                            <span class="info data">{{ Shop.cTenNganHang }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog v-model="centerDialogVisible" class="modalTemp" dataBackDrop="static" :show-close="false">
            <template #header="{ close, titleId, titleClass }">
                <div class="d-flex justify-content-between px-4 pt-4">
                    <h2 slot="header" class="modal-title">Cập nhật thông tin cửa hàng</h2>
                    <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal"
                        @click="centerDialogVisible = false">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
                        </span>
                    </div>
                </div>
            </template>
            <el-form :model="validateForm" :rules="rules" ref="validateForm" label-width="150px" class="demo-ruleForm">
                <div class="w-100">
                    <div class="w-100" v-if="!operation">
                        <el-form-item label="Tên cửa hàng" prop="cTenCuaHang">
                            <el-input :size="size" v-model="validateForm.cTenCuaHang"></el-input>
                        </el-form-item>
                        <el-form-item label="Địa chỉ" prop="cDiaChi">
                            <el-input :size="size" v-model="validateForm.cDiaChi"></el-input>
                        </el-form-item>
                        <el-form-item label="Số điện thoại" prop="cSDT">
                            <el-input :size="size" v-model="validateForm.cDienThoai"></el-input>
                        </el-form-item>
                        <el-form-item label="Ảnh đại diện">
                            <el-upload class="image-uploader" action="#" :auto-upload="false"
                                :on-change="onAvatarChange" :show-file-list="false" accept="image/*">
                                <img v-if="shopAvatar.url" :src="shopAvatar.url" class="avatar avatar-shop">
                                <i v-else class="el-icon-plus avatar-uploader-icon" />
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="Ảnh bìa">
                            <el-upload class="image-uploader" action="#" :auto-upload="false"
                                :on-change="onBannerChange" :show-file-list="false" accept="image/*">
                                <img v-if="shopBanner.url" :src="shopBanner.url" class="avatar banner-shop">
                                <i v-else class="el-icon-plus avatar-uploader-icon" />
                            </el-upload>
                        </el-form-item>
                    </div>
                    <div class="w-100" v-if="operation">
                        <el-form-item label="Số tài khoản" prop="cSoTaiKhoanNganHang">
                            <el-input :size="size" v-model="validateForm.cSoTaiKhoanNganHang"></el-input>
                        </el-form-item>
                        <el-form-item label="Tên chủ tài khoản" prop="cTenChuTaiKhoan">
                            <el-input :size="size" v-model="validateForm.cTenChuTaiKhoan"></el-input>
                        </el-form-item>
                        <el-form-item label="Mã ngân hàng" prop="nMaNganHang">
                            <el-select filterable placeholder="Chọn ngân hàng" v-model="validateForm.nMaNganHang"
                                style="width: 50%;">
                                <el-option v-for="item in bankList" :key="item.nMaNganHang" :label="item.cTenNganHang"
                                    :value="item.nMaNganHang">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
            <template #footer>
                <el-button type="primary" @click="save" v-loading.fullscreen.lock="isLoading">Lưu</el-button>
                <el-button outline type="danger" @click="handleClose">Thoát</el-button>
            </template>
        </el-dialog>

        <el-dialog v-model="certificateModal" class="modalTemp" dataBackDrop="static" :show-close="false">
            <template #header="{ close, titleId, titleClass }">
                <div class="d-flex justify-content-between px-4 pt-4">
                    <h2 slot="header" class="modal-title">
                        {{ operation ? "Thêm giấy phép" : preview ? "Chi tiết giấy phép" : "Thêm tin" }}
                    </h2>
                    <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal"
                        @click="certificateModal = false">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
                        </span>
                    </div>
                </div>
            </template>
            <el-form :model="certificateForm" :rules="certiRules" ref="certificateForm" label-width="150px"
                class="demo-ruleForm flex-column">
                <el-form-item label="Tên giấy phép:" prop="cTenGiay">
                    <el-input :readonly="preview" :size="size" v-model="certificateForm.cTenGiay"></el-input>
                </el-form-item>
                <el-form-item label="Mô tả:" prop="cMoTa">
                    <el-input :readonly="preview" :size="size" v-model="certificateForm.cMoTa"></el-input>
                </el-form-item>
                <el-form-item label="Ngày hiệu lực:" prop="dNgayHieuLuc">
                    <el-date-picker :disabled="preview" v-model="certificateForm.dNgayHieuLuc" type="date"
                        placeholder="Chọn ngày" :size="size" />
                </el-form-item>
                <el-form-item label="file scan:" prop="scanfile">
                    <el-upload v-if="!preview" action="#" accept="application/pdf" class="demo-upload"
                        :auto-upload="false" :on-change="fileChanged" :file-list="certificateForm.scanfile"
                        :on-remove="fileRemoved">
                        <el-button v-if="!preview" type="primary">Chọn file</el-button>
                    </el-upload>
                    <div v-if="!operation && preview && selected.scanfile" style="display: flex; align-items: center;">
                        <a :href="handleDownloadFile(selected.scanfile)" download>{{ selected.scanfile }}</a>
                        <div class="file-delete" @click="handleDeleteFile(selected)">
                            <i class="fa fa-times"></i>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button v-if="operation" type="success" @click="handleAddCerti"
                    v-loading.fullscreen.lock="isLoading">Lưu</el-button>
                <el-button v-if="!operation && preview" type="primary" @click="handleOpenEditCerti"
                    v-loading.fullscreen.lock="isLoading">Sửa</el-button>
                <el-button v-if="!operation && preview" type="danger" @click="handleDeleteCertificate(selected)"
                    v-loading.fullscreen.lock="isLoading">Xóa</el-button>
                <el-button v-if="!operation && !preview" type="success" @click="handleEditCerti(selected)"
                    v-loading.fullscreen.lock="isLoading">Lưu</el-button>
                <el-button v-if="!operation && !preview" type="danger" @click="preview = true"
                    v-loading.fullscreen.lock="isLoading">Hủy</el-button>

                <el-button outline type="danger" @click="handleClose">Thoát</el-button>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import moment from "moment";
import { ElMessage } from "element-plus";
import { baseUrl } from "@/utils/global";
import { useStore } from "vuex";
import ImageResize from "quill-image-resize";
import { QuillEditor, Quill } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import { Bank, Certificate, Common, Shop } from "@/store/enums/StoreEnums";
Quill.register("modules/imageResize", ImageResize);
export default {
    components: {
        QuillEditor
    },
    data() {
        return {
            store: useStore(),
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                ["bold", "italic", "underline"],
                [{ 'size': ['small', false, 'large', 'huge'] }],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ 'color': [] }, { 'background': [] }],
                [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
                [{ indent: "-1" }, { indent: "+1" }],
                ["link"], ["clean"]
            ],
            quillOptions: {
                theme: 'snow',
                modules: {
                    imageResize: {},
                    toolbar: {
                        container: [
                            [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                            ["bold", "italic", "underline"],
                            [{ list: "ordered" }, { list: "bullet" }],
                            [{ 'color': [] }, { 'background': [] }],
                            [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
                            [{ indent: "-1" }, { indent: "+1" }],
                            ["image", "link"], ["clean"],
                        ],
                        handlers: {
                            image: this.customImageHandler
                        }
                    }
                }
            },
            size: "",
            shopAvatar: {
                file: null,
                url: ""
            },
            shopBanner: {
                file: null,
                url: ""
            },

            imgBanner: [],
            Shop: {
                nMaCuaHang: "",
                cTenCuaHang: "",
                cDienThoai: "",
                cDiaChi: "",
                cSoTaiKhoanNganHang: "",
                cTenChuTaiKhoan: "",
                nMaNganHang: "",
                cGioiThieu: ""
            },
            isLoading: false,
            centerDialogVisible: false,
            certificateModal: false,
            operation: false,
            validateForm: {
                nMaCuaHang: "",
                cTenCuaHang: "",
                cDienThoai: "",
                cDiaChi: "",
                cSoTaiKhoanNganHang: "",
                cTenChuTaiKhoan: "",
                nMaNganHang: ""
            },
            certificateForm: {
                cTenGiay: "",
                cMoTa: "",
                dNgayHieuLuc: null,
                scanfile: []
            },
            certiRules: {
                cTenGiay: [
                    { required: true, message: "Xin vui lòng nhập tên giấy phép", trigger: "blur", },
                ],
                dNgayHieuLuc: [
                    { required: true, message: "Xin vui lòng nhập ngày hiệu lực", trigger: "blur", },
                ]
            },
            description: "",
            dUpdate: true,
            rules: {
                nMaCuaHang: [
                    { required: true, message: "Xin vui lòng nhập tên chi nhánh", trigger: "blur", },
                ],
                cTenCuaHang: [
                    { required: true, message: "Xin vui lòng nhập địa chỉ", trigger: "blur", },
                ],
                cDienThoai: [
                    { required: true, message: "Xin vui lòng nhập số điện thoại", trigger: "blur", },
                ]
            },
            bankList: [],
            certificate: [],
            selected: {},
            preview: false,
        }
    },
    computed: {
    },
    methods: {
        onTextChange(val) {
            this.description = this.$refs.quillEditor.getHTML()
        },
        renderImg(img) {
            return baseUrl + '/product/img/' + img
        },
        handleMaxLenght(val) {

        },
        handleDeleteFile(val) {
            this.$confirm("Bạn có muốn xóa file scan " + val.scanfile + " không?", "Xác nhận", {
                confirmButtonText: "Xác nhận",
                cancelButtonText: "Hủy",
                type: "warning",
            })
                .then(() => {
                    let pageRequest = {
                        columnFilters: {
                            fileName: { value: val.scanfile },
                            nMaGiayPhep: { value: val.nMaGiayPhep }
                        }
                    }
                    this.store.dispatch(Certificate.deleteFileScan, pageRequest).then(res => {
                        if (res.code == 200) {
                            ElMessage({ message: res.msg, type: "success" })
                            this.certificateModal = false
                            this.handleFindCertificate()
                        } else {
                            ElMessage({ message: res.msg, type: "error" })
                            this.certificateModal = false
                        }
                    })
                })
        },
        handleDownloadFile(fileName) {
            return "certificate/" + fileName
        },
        fileChanged(file, fileList) {
            this.certificateForm.scanfile = [file]
        },

        fileRemoved(file, fileList) {
            this.certificateForm.scanfile = []
        },
        handleOpenEditCerti() {
            this.preview = false
        },
        handleEditCerti(val) {
            this.$refs.certificateForm.validate((valid) => {
                if (valid) {
                    let pageRequest = {
                        columnFilters: {
                            cTenGiay: { value: this.certificateForm.cTenGiay },
                            cMoTa: { value: this.certificateForm.cMoTa },
                            dNgayHieuLuc: { value: moment(this.certificateForm.dNgayHieuLuc).format("DD/MM/YYYY") },
                            cOldFile: { value: val.scanfile },
                            nMaGiayPhep: { value: val.nMaGiayPhep },
                        }
                    }
                    const formData = new FormData();

                    if (this.certificateForm.scanfile.length > 0) {
                        formData.append('file', this.certificateForm.scanfile[0].raw);
                    }
                    formData.append('data', new Blob([JSON.stringify(pageRequest)], { type: "application/json" }));
                    this.store.dispatch(Certificate.editCertificate, formData).then(res => {
                        if (res.code == 200) {
                            ElMessage({ message: res.msg, type: "success" })
                            this.certificateModal = false
                            this.handleFindCertificate()
                        }
                        else {
                            ElMessage({ message: res.msg, type: "error" })
                        }
                    })
                }

            })
        },
        handleOpenCertificate(val) {
            this.preview = true
            this.certificateModal = true
            this.operation = false
            this.selected = {
                nMaGiayPhep: val.n_ma_giay_phep,
                cTenGiay: val.c_ten_giay_phep,
                cMoTa: val.c_mo_ta,
                dNgayHieuLuc: val.d_ngay_hieu_luc,
                scanfile: val.c_scan_file
            }
            this.certificateForm = {
                nMaGiayPhep: val.n_ma_giay_phep,
                cTenGiay: val.c_ten_giay_phep,
                cMoTa: val.c_mo_ta,
                dNgayHieuLuc: val.d_ngay_hieu_luc,
                scanfile: []
            }
        },

        handleOpenAddCer() {
            this.preview = false
            this.certificateModal = true
            this.operation = true
            this.certificateForm = {
                cTenGiay: "",
                cMoTa: "",
                dNgayHieuLuc: "",
                scanfile: []
            }
        },

        handleAddCerti() {
            this.$refs.certificateForm.validate((valid) => {
                if (valid) {
                    let pageRequest = {
                        columnFilters: {
                            cTenGiay: { value: this.certificateForm.cTenGiay },
                            cMoTa: { value: this.certificateForm.cMoTa },
                            dNgayHieuLuc: { value: moment(this.certificateForm.dNgayHieuLuc).format("DD/MM/YYYY") },
                        }
                    }
                    const formData = new FormData();

                    if (this.certificateForm.scanfile.length > 0) {
                        formData.append('file', this.certificateForm.scanfile[0].raw);
                    }
                    formData.append('data', new Blob([JSON.stringify(pageRequest)], { type: "application/json" }));
                    this.store.dispatch(Certificate.createCertificate, formData).then(res => {
                        if (res.code == 200) {
                            ElMessage({ message: res.msg, type: "success" })
                            this.certificateModal = false
                            this.handleFindCertificate()
                        }
                        else {
                            ElMessage({ message: res.msg, type: "error" })
                        }
                    })
                }
            })
        },

        handleFindCertificate() {
            this.store.dispatch(Certificate.findPageCertificate).then(res => {
                if (res.code == 200) {
                    this.certificate = res.data
                } else {
                    ElMessage({ message: "Có lỗi xảy ra xin vui lòng thử lại sau", type: "error" })
                }
            })
        },

        handleDeleteCertificate(val) {
            this.$confirm("Bạn có muốn xóa giấy phép " + val.cTenGiay + " không?", "Xác nhận", {
                confirmButtonText: "Xác nhận",
                cancelButtonText: "Hủy",
                type: "warning",
            })
                .then(() => {
                    let pageRequest = {
                        columnFilters: {
                            nMaGiayPhep: { value: val.nMaGiayPhep },
                            cFileName: { value: val.scanfile }
                        }
                    }
                    this.store.dispatch(Certificate.deleteCertificate, pageRequest).then(res => {
                        if (res.code == 200) {
                            ElMessage({ message: res.msg, type: "success" })
                            this.certificateModal = false
                            this.handleFindCertificate()
                        } else {
                            ElMessage({ message: res.msg, type: "error" })
                        }
                    })
                })
        },
        handleOpenDescription() {
            this.dUpdate = true
            this.description = this.Shop.cGioiThieu
            this.$refs.quillEditor.setHTML(this.description)
        },
        handleUpdateDescription() {
            this.store.dispatch(Shop.updateShopDescription, this.description).then(res => {
                if (res.code == 200) {
                    ElMessage({ message: res.msg, type: "success" })
                    this.handleFindStoreInfo()
                    this.dUpdate = false
                } else {
                    ElMessage({ message: res.msg, type: "error" })
                }
            })
        },
        handleCancelDescription() {
            this.dUpdate = false
        },
        handleFindStoreInfo() {
            this.store.dispatch(Shop.findShopInfo).then(res => {
                if (res.code == 200) {
                    this.Shop = res.data[0]
                }
            })
        },
        handleClose() {
            this.certificateModal = false
            this.centerDialogVisible = false
            this.validateForm = {
                nMaCuaHang: "",
                cTenCuaHang: "",
                cDienThoai: "",
                cDiaChi: "",
                cSoTaiKhoanNganHang: "",
                cTenChuTaiKhoan: "",
                nMaNganHang: ""
            }
            this.certificateForm = {
                cTenGiay: "",
                cMoTa: "",
                dNgayHieuLuc: ""
            }
        },
        handleOpenUpdate(val) {
            if (this.Shop.profileImage) this.shopAvatar.url = this.renderImg(this.Shop.profileImage)
            if (this.Shop.profileBanner) this.shopBanner.url = this.renderImg(this.Shop.profileBanner)
            this.validateForm = {
                nMaCuaHang: this.Shop.nMaCuaHang,
                cTenCuaHang: this.Shop.cTenCuaHang,
                cDienThoai: this.Shop.cDienThoai,
                cDiaChi: this.Shop.cDiaChi,
                cSoTaiKhoanNganHang: this.Shop.cSoTaiKhoanNganHang,
                cTenChuTaiKhoan: this.Shop.cTenChuTaiKhoan,
                nMaNganHang: this.Shop.nMaNganHang
            }
            this.operation = val
            this.centerDialogVisible = true
        },
        save() {
            this.$refs.validateForm.validate(async (valid) => {
                if (valid) {
                    this.isLoading = true
                    let params = Object.assign({}, this.validateForm);

                    if (this.shopAvatar.file) {
                        const resAva = await this.store.dispatch(Common.uploadImg, this.shopAvatar.file)
                        if (resAva.code == 200) params.profileImage = resAva.data
                    }
                    if (this.shopBanner.file) {
                        const resBanner = await this.store.dispatch(Common.uploadImg, this.shopBanner.file)
                        if (resBanner.code === 200) params.profileBanner = resBanner.data
                    }

                    const res = await this.store.dispatch(Shop.saveShop, params)
                    if (res.code == 200) {
                        if (this.operation == false) {
                            ElMessage({ message: "Cập nhật thông tin cửa hàng thành công!", type: "success", });
                        } else {
                            ElMessage({
                                message: "Cập nhật thông tin tài khoản thành công!",
                                type: "success",
                            });
                        }
                        this.$refs["validateForm"].resetFields();
                        this.centerDialogVisible = false;
                        this.isLoading = false
                        this.handleFindStoreInfo();
                    } else {
                        if (this.operation == false) {
                            ElMessage({
                                message: "Cập nhật thông tin cửa hàng thất bại!",
                                type: "error",
                            });
                        } else {
                            ElMessage({
                                message: "Cập nhật thông tin tài khoản thất bại!",
                                type: "error",
                            });
                        }
                        this.$refs["validateForm"].resetFields();
                        this.centerDialogVisible = false;
                        this.isLoading = false
                    }
                }
            });
        },
        getBankList() {
            this.store.dispatch(Bank.showBank).then((res) => {
                if (res.code == 200 && res.data)
                    this.bankList = res.data
                else
                    this.bankList = []
            })
        },
        onAvatarChange(file) {
            if (file.size / 1024 / 1024 > 1) {
                ElMessage({ message: 'Kích thước ảnh phải nhỏ hơn 1MB!', type: "error" });
                this.fileList = []
                return
            }
            // this.imgAvatar = [file]
            this.shopAvatar.file = file.raw
            this.shopAvatar.url = URL.createObjectURL(file.raw);
        },
        onBannerChange(file) {
            if (file.size / 1024 / 1024 > 1) {
                ElMessage({ message: 'Kích thước ảnh phải nhỏ hơn 1MB!', type: "error" });
                this.fileList = []
                return
            }
            this.shopBanner.file = file.raw
            this.shopBanner.url = URL.createObjectURL(file.raw);
        },
        onAvatarRemove(file) {

        },
        test(event) {
            this.shopAvatar.url = URL.createObjectURL(event.target.files[0]);
            console.log(this.shopAvatar.url);
        },
        momentDate(val) {
            return val ? moment(val).format("DD/MM/YYYY") : ""
        }
    },
    mounted() {
        this.handleFindStoreInfo()
        this.getBankList()
        this.handleFindCertificate()
        this.dUpdate = false
    }
}
</script>
<style lang="scss" scoped>
.avatar-shop {
    width: 100px;
    height: 100px;
}

.banner-shop {
    width: 100%;
    height: 100%;
}

.test::v-deep p {
    font-size: medium;
    font-weight: normal;

    .ql-size-small {
        font-size: 0.75em;
    }

    .ql-size-large {
        font-size: 1.5em;
    }

    .ql-size-huge {
        font-size: 2.5em;
    }
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
}

.file-delete:hover {
    cursor: pointer;
}

.file-delete {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
}

.upload {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    flex-direction: column;
}

.input {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;

    .counter {
        font-style: italic;
        color: rgba(128, 128, 128, 0.671);
    }
}

.info-page-header {
    background-color: whitesmoke;
    padding: 10px 30px 10px 30px;
    box-shadow: rgb(204, 204, 204) 1px 1px 5px 0px;

    h3 {
        margin: 0;
    }
}

.card{
    margin: 20px;
    border-radius: 10px;
    border: 1px solid rgb(189, 189, 189);
}

.addIcon {
    font-size: 1.5rem;
    color: #007bff;
}

.CerCard {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.CerCard:hover {
    cursor: pointer;
    background-color: #007bff;

    .addIcon {
        color: whitesmoke;
        transition: ease-in 0.5s;
    }

    transition: ease-in 0.5s;

    .info {
        color: whitesmoke;
        transition: ease-in 0.5s;
    }
}

.info-card {
    padding: 10px 20px 10px 20px;
    border-top: 1px solid rgb(189, 189, 189);

}

.info-title {
    padding: 10px 20px 10px 20px;
    display: flex;
    justify-content: space-between;

    .title-btn {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.info {
    font-size: large;
    font-weight: bold;
}

.data {
    color: #525f7f;
}
</style>
<style lang="scss">
.certi {
    .div__body {
        padding-bottom: 0px !important;
    }
}

.image-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.image-uploader .el-upload:hover {
    border-color: #409EFF;
}
</style>
